<template>
	<v-layout class="vacation">
		<Slider v-if="!edit && !add && imagesAvailable" :title="this.$route.params.id" />
		<Create v-if="(add && !isViewer) || (!imagesAvailable && !isViewer)" :reset-add="resetAdd" :multi="true" :is-overview="false" />
		<Edit v-if="edit && !isViewer && imagesAvailable" :reset-edit="resetEdit" :is-overview="false" />
		<v-speed-dial v-if="!isViewer" v-model="fab" left bottom fixed direction="top" transition="slide-y-reverse-transition">
			<template v-slot:activator>
				<v-btn v-model="fab" :dark="fab" fab>
					<v-icon>settings</v-icon>
					<v-icon>close</v-icon>
				</v-btn>
			</template>
			<v-btn v-if="!add && !edit && imagesAvailable" fab dark small color="green" @click="edit = !edit">
				<v-icon>edit</v-icon>
			</v-btn>
			<v-btn v-if="!add && !edit" fab dark small color="indigo" @click="add = !add">
				<v-icon>add</v-icon>
			</v-btn>
			<v-btn v-if="add || edit" fab dark small color="indigo" @click="update()">
				<v-icon>grid_on</v-icon>
			</v-btn>
		</v-speed-dial>
	</v-layout>
</template>

<script>
import Create from '@/components/Create.vue'
import Slider from '@/components/Slider.vue'
import Edit from '@/components/Edit.vue'
export default {
	name: 'Vacation',
	components: {
		Create,
		Slider,
		Edit
	},
	data: () => ({
		fab: false,
		add: false,
		edit: false
	}),
	computed: {
		isViewer() {
			return this.$store.state.user.type == 'viewer'
		},
		imagesAvailable() {
			return this.$store.state.images.length > 0
		},
		images() {
			return this.$store.state.images
		}
	},
	mounted() {
		this.$store.dispatch('getVacations')
		this.$store.dispatch('getVacation', this.$route.params.id)
	},
	methods: {
		resetAdd() {
			this.add = false
		},
		resetEdit() {
			this.edit = false
		},
		update() {
			this.add = false
			this.edit = false
			this.$store.dispatch('update', {
				items: this.images,
				table: 'images'
			})
		}
	}
}
</script>
